import axiosInstance from './axiosInstance';
import { useQuery } from '@tanstack/react-query';
import type { TeamGetAllParams, TeamsResponse } from '@/types/team.types';
import type { GenericErrorResponseError } from '@/types/api.types';

export const useTeamGetAll = (params?: TeamGetAllParams) => {
  return useQuery<TeamsResponse, GenericErrorResponseError>({
    queryKey: ['teams', params?.userName, params?.search, params?.teamId, params?.userStatus],
    queryFn: async () => {
      const response = await axiosInstance.get<TeamsResponse>(`/teams`, {
        params,
      });
      return response.data;
    },
  });
};
